import { DynamicShared } from "../dynamicShared";
import { Toolbar, FilterButton, ColumnFilterButton, ToolbarTab } from "./Toolbar";
import { CreateNewButton } from "./CreateNewButton";
import { ExportButton } from "./ExportButton";
import { useFormattedDateTime } from "./useFormattedDateTime";
import { dateTimeColumn } from "./dateTimeColumn";
import {
  DynamicGrid as Grid,
  DynamicGridFooter,
  DynamicGridDrawer,
  MAIN_COLUMN_WIDTH,
  useGetFilteredRowsData,
  useGridContext,
  MAIN_FIELD,
  setupRoutes,
  useSelectedRowId,
  selectedRowIdFromParams,
  useInitialisedGridApiRef,
} from "./DynamicGrid";
import { optionFilterSearch } from "./optionFilterFromSearchParams";
import { requiredColDef } from "./misc";
import { OpenSubDrawerLink } from "./OpenSubDrawerLink";
import { SubSidePanelBackButton, useGoToSidePanel } from "./SidePanels";
import {
  Cell,
  EmptyCell,
  LimitVisibleItems,
  PersonCell,
  TextCellContent,
  TextInputCell,
  yesOrNoFilterOperator,
} from "./columnDefinitions";
import { CardList } from "./CardList";

export const DynamicGrid = {
  /** Components */
  Grid,
  CardList,
  Toolbar,
  ToolbarTab,
  CreateNewButton,
  ExportButton,
  Footer: DynamicGridFooter,
  OpenSubDrawerLink,
  FilterButton,
  ColumnFilterButton,
  Drawer: DynamicGridDrawer,
  SubSidePanelBackButton,
  LimitVisibleItems,
  Chip: DynamicShared.Chip,
  Cell,
  EmptyCell,
  PersonCell,
  TextCellContent,
  TextInputCell,
  /** Helpers */
  dateTimeColumn,
  requiredColDef,
  yesOrNoFilterOperator,
  useFormattedDateTime,
  useGoToSidePanel,
  useGetFilteredRowsData,
  useInitialisedGridApiRef,
  useGridContext,
  setupRoutes,
  useSelectedRowId,
  selectedRowIdFromParams,
  optionFilterSearch,
  /** Constants */
  MAIN_COLUMN_WIDTH,
  MAIN_FIELD,
};
